import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaWhatsapp,
  FaArrowRight,
  FaCalendarAlt,
  FaTag,
  FaFolderOpen,
  FaShareAlt,
  FaExternalLinkAlt
} from 'react-icons/fa';

import ReactHtmlParser from 'react-html-parser';

import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';

import '../components/cssfile/question_paper.css';
import '../components/cssfile/job.css';
import '../components/cssfile/job-detail.css';

class JobDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      jobDetail: null,
      relatedArticles: [],
      error: null,
      loading: true
    };
  }

  componentDidMount() {
    this.loadJobDetail();
    this.fetchRelatedArticles();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.slug !==
      this.props.match.params.slug
    ) {
      this.loadJobDetail();
    }
  }

  /*
   * =========================================================
   * CREATE SLUG
   * =========================================================
   */

  createSlug = (value = '') => {
    return value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  /*
   * =========================================================
   * LOAD JOB DETAIL
   * =========================================================
   */

  loadJobDetail = () => {
    const { slug } = this.props.match.params;

    if (!slug) {
      this.setState({
        error: 'No article found.',
        loading: false
      });

      return;
    }

    this.setState({
      loading: true,
      error: null
    });

    this.fetchJobDetail(slug);
  };

  /*
   * =========================================================
   * FETCH JOB DETAIL
   * =========================================================
   */

  fetchJobDetail = (slug) => {
    axios
      .get(`${apiUrl}serverside/latest_job.php`)
      .then((response) => {

        const matchedJob = response.data.find(
          (job) =>
            this.createSlug(job.topic_name) === slug
        );

        if (matchedJob) {
          this.setState({
            jobDetail: matchedJob,
            error: null,
            loading: false
          });
        } else {
          this.setState({
            jobDetail: null,
            error: 'Article not found.',
            loading: false
          });
        }
      })
      .catch((error) => {

        console.error(
          'Job detail error:',
          error
        );

        this.setState({
          jobDetail: null,
          error: 'Failed to fetch article details.',
          loading: false
        });
      });
  };

  /*
   * =========================================================
   * FETCH RELATED ARTICLES
   * =========================================================
   */

  fetchRelatedArticles = () => {
    axios
      .get(`${apiUrl}serverside/latest_job.php`)
      .then((response) => {

        const latestArticles = [...response.data]
          .sort(
            (a, b) =>
              new Date(b.date) -
              new Date(a.date)
          )
          .slice(0, 10);

        this.setState({
          relatedArticles: latestArticles
        });
      })
      .catch((error) => {

        console.error(
          'Related articles error:',
          error
        );
      });
  };

  /*
   * =========================================================
   * SOCIAL SHARING
   * =========================================================
   */

  renderSocialSharing = () => {

    const currentUrl = encodeURIComponent(
      window.location.href
    );

    return (
      <div className="job-share-box">

        <div className="job-share-heading">

          <div className="job-share-icon">
            <FaShareAlt />
          </div>

          <div>
            <h5>
              Share this article
            </h5>

            <p>
              Help others discover this update
            </p>
          </div>

        </div>

        <div className="job-social-buttons">

          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="job-social facebook"
            aria-label="Share on Facebook"
          >
            <FaFacebookF />
            <span>
              Facebook
            </span>
          </a>

          <a
            href={`https://twitter.com/intent/tweet?url=${currentUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="job-social twitter"
            aria-label="Share on Twitter"
          >
            <FaTwitter />
            <span>
              Twitter
            </span>
          </a>

          <a
            href={`https://www.linkedin.com/shareArticle?url=${currentUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="job-social linkedin"
            aria-label="Share on LinkedIn"
          >
            <FaLinkedinIn />
            <span>
              LinkedIn
            </span>
          </a>

          <a
            href={`https://wa.me/?text=${currentUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="job-social whatsapp"
            aria-label="Share on WhatsApp"
          >
            <FaWhatsapp />
            <span>
              WhatsApp
            </span>
          </a>

        </div>

      </div>
    );
  };

  /*
   * =========================================================
   * ARTICLE META
   * =========================================================
   */

  renderMeta = () => {

    const { jobDetail } = this.state;

    return (
      <div className="job-detail-meta">

        {jobDetail.date && (
          <div className="job-meta-item">

            <FaCalendarAlt />

            <span>
              {jobDetail.date}
            </span>

          </div>
        )}

        {jobDetail.exam_category && (
          <div className="job-meta-item">

            <FaFolderOpen />

            <span>
              {jobDetail.exam_category}
            </span>

          </div>
        )}

        {jobDetail.category && (
          <div className="job-meta-item">

            <FaTag />

            <span>
              {jobDetail.category}
            </span>

          </div>
        )}

      </div>
    );
  };

  /*
   * =========================================================
   * SPONSORED SECTION
   * =========================================================
   */

  renderSponsored = () => {

    return (
      <div className="job-sidebar-card">

        <div className="job-sidebar-heading">

          <span className="job-sidebar-label">
            SPONSORED
          </span>

          <h3>
            Advertisement
          </h3>

        </div>

        <div className="job-ad-box">

          <span>
            ADVERTISEMENT
          </span>

          <strong>
            Your Advertisement Here
          </strong>

          <small>
            Reach thousands of exam aspirants
          </small>

        </div>

      </div>
    );
  };

  /*
   * =========================================================
   * RELATED ARTICLES
   * =========================================================
   */

  renderRelatedArticles = () => {

    const {
      relatedArticles
    } = this.state;

    return (
      <div className="job-sidebar-card">

        <div className="job-sidebar-heading">

          <span className="job-sidebar-label">
            EXPLORE MORE
          </span>

          <h3>
            Related Articles
          </h3>

        </div>

        {relatedArticles.length > 0 ? (

          <div className="job-related-list">

            {relatedArticles.map((article, index) => {

              const slug = this.createSlug(
                article.topic_name
              );

              return (
                <Link
                  key={article.id || index}
                  to={`/job_detail/${slug}`}
                  className="job-related-item"
                >

                  <div className="job-related-number">
                    {String(index + 1).padStart(2, '0')}
                  </div>

                  <div className="job-related-content">

                    <h4>
                      {
                        article.title ||
                        article.topic_name
                      }
                    </h4>

                    {article.date && (
                      <span>
                        {article.date}
                      </span>
                    )}

                  </div>

                  <FaArrowRight
                    className="job-related-arrow"
                  />

                </Link>
              );

            })}

          </div>

        ) : (

          <div className="job-related-empty">
            No related articles available.
          </div>

        )}

      </div>
    );
  };

  /*
   * =========================================================
   * LOADING SCREEN
   * =========================================================
   */

  renderLoading = () => {

    return (
      <div className="job-detail-page">

        <Header />

        <div className="job-detail-loading">

          <div className="job-loading-spinner" />

          <h3>
            Loading article...
          </h3>

          <p>
            Please wait while we load the
            latest information.
          </p>

        </div>

        <Footer />

      </div>
    );
  };

  /*
   * =========================================================
   * ERROR SCREEN
   * =========================================================
   */

  renderError = () => {

    const {
      error
    } = this.state;

    return (
      <div className="job-detail-page">

        <Header />

        <div className="job-detail-error">

          <div className="job-error-icon">
            !
          </div>

          <h2>
            {error || 'Article not found.'}
          </h2>

          <p>
            The article you are looking for
            may have been removed or is
            temporarily unavailable.
          </p>

          <Link
            to="/job"
            className="job-back-button"
          >
            <FaArrowRight />

            Back to Latest Updates
          </Link>

        </div>

        <Footer />

      </div>
    );
  };

  /*
   * =========================================================
   * MAIN RENDER
   * =========================================================
   */

  render() {

    const {
      jobDetail,
      error,
      loading
    } = this.state;

    /*
     * Loading
     */

    if (loading) {
      return this.renderLoading();
    }

    /*
     * Error
     */

    if (error || !jobDetail) {
      return this.renderError();
    }

    return (
      <div className="job-detail-page">

        <Header />

        <main className="job-detail-wrapper">

          <div className="container">

            <div className="row g-4">

              {/* =================================================
                  MAIN ARTICLE
              ================================================= */}

              <div className="col-lg-8">

                <article className="job-article-card">

                  {/* Article Header */}

                  <div className="job-article-header">

                    <div className="job-article-label">
                      LATEST UPDATE
                    </div>

                    <h1>
                      {
                        jobDetail.title ||
                        jobDetail.topic_name
                      }
                    </h1>

                    {this.renderMeta()}

                  </div>


                  {/* Divider */}

                  <div className="job-article-divider" />


                  {/* Article Content */}

                  <div className="job-article-content">

                    {ReactHtmlParser(
                      jobDetail.des
                    )}

                  </div>


                  {/* Official Source */}

                  {jobDetail.url && (

                    <div className="job-source-box">

                      <div>

                        <strong>
                          Official Source
                        </strong>

                        <p>
                          Visit the official
                          source for complete
                          information.
                        </p>

                      </div>

                      <a
                        href={jobDetail.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="job-source-button"
                      >
                        Visit Source

                        <FaExternalLinkAlt />

                      </a>

                    </div>

                  )}


                  {/* Social Sharing */}

                  {this.renderSocialSharing()}

                </article>

              </div>


              {/* =================================================
                  SIDEBAR
              ================================================= */}

              <aside className="col-lg-4">

                <div className="job-sidebar">

                  {this.renderSponsored()}

                  {this.renderRelatedArticles()}

                </div>

              </aside>

            </div>

          </div>

        </main>

        <Footer />

      </div>
    );
  }
}

export default JobDetail;